import React, { ReactNode } from 'react'
import { connect, DispatchProp } from 'react-redux'
import { RouteComponentProps } from 'react-router-dom'
import { Button, Page, Spinner } from '../../../components'
import { images } from '../../../images'
import literalsService from '../../../services/literals-service'
import { saveUserLanguageAction, setChangeLanguageAction, setNotificationAction } from '../../../store/actions'
import { IStoreState } from '../../../store/states'
import StyledArticle from './styles'
import { appsLanguagePositionSelected, appsStyleSelected } from '../../../helpers/app'
import { AuthenticatedRoutable } from '../../../models'

interface IProps extends RouteComponentProps, DispatchProp<any> {
  language: string
  isLoadingUserInfo: boolean
}

type IState = {
  locale: string
}

class ChangeLanguage extends AuthenticatedRoutable<IProps, IState> {

  constructor(props: any) {
    super(props)
    this.state = {
      locale: props.language
    }
  }
  
  public componentDidMount() {
    super.componentDidMount()
  }

  public render(): ReactNode {
    const { isLoadingUserInfo } = this.props
    if (isLoadingUserInfo) {
      return (
        <article className="spinner-container">
          <Spinner />
        </article>
      )
    }
    return (
      <Page>
        <Page className={ `authenticated ${appsStyleSelected?.style}` }>
          <StyledArticle>
            <img src={ images['goBack'] } className='backButton' onClick={ this.handleGoBack } />
            <form onSubmit={ e => e.preventDefault() }>
              <section>
                <h3>{ literalsService.get('changeLanguage', true) }</h3>
                <section>
                  {
                    appsLanguagePositionSelected?.languages.map((language: string) => {
                      return (
                        <section key={`language-${language}`} className='row' onClick={() => this.handleLanguagePress(language)}>
                          <img className='flag' src={ images[language] } />
                          <p> { literalsService.get(language, true) } </p>
                          { literalsService.getLanguage() === language ?
                            <img className='check' src={ images['checkLanguage'] } />
                          : null }
                        </section>
                      )
                    })
                  }
                </section>
                <Button
                  title={ literalsService.get('save', true) }
                  onPress={ () => this.saveUserInfo() }
                  className={ 'saveButton' }
                  filled
                  upper
                />
              </section>
            </form>
          </StyledArticle>
        </Page>
      </Page>
    )
  }

  private handleGoBack = (): void => {
    literalsService.setLanguage(this.props.language)
    history.back()
  }

  private handleLanguagePress = (language: any) => {
    literalsService.setLanguage(language)
    this.setState({locale: language})
  }

  private saveUserInfo = () => {
    const { dispatch } = this.props
    const { locale } = this.state
    dispatch(saveUserLanguageAction(locale))
    dispatch(setChangeLanguageAction(locale))
    dispatch(setNotificationAction({
      label: literalsService.get('languageChanged', true),
      isError: false
    }))
  }
}

const mapStateToProps = ({ userInfo, configuration }: IStoreState) => ({
  language: configuration.language,
  isLoadingUserInfo: userInfo.isLoadingUserInfo
})

export default connect(mapStateToProps)(ChangeLanguage)
